(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["group"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.theronaScrollRevealInit) return;
    window.theronaScrollRevealInit = true;

    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var observer = null;
    if (!reduceMotion && 'IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-in-view');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.1, rootMargin: '0px 0px -10% 0px' }
      );
    }

    function revealNow(el) {
      el.classList.add('is-in-view');
    }

    function observeAll(root) {
      var els = root.querySelectorAll
        ? root.querySelectorAll('[data-scroll-reveal]:not([data-scroll-reveal-bound])')
        : [];
      els.forEach(function (el) {
        el.setAttribute('data-scroll-reveal-bound', '');
        if (observer) {
          observer.observe(el);
        } else {
          revealNow(el);
        }
      });
    }

    observeAll(document);

    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-scroll-reveal]')) {
            observeAll(node.parentNode || document);
          } else if (node.querySelectorAll) {
            observeAll(node);
          }
        });
      });
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["image"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.theronaParallaxInit) return;
    window.theronaParallaxInit = true;

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var activeEls = new Set();
    var rafId = null;

    function tick() {
      activeEls.forEach(function (el) {
        var rect = el.getBoundingClientRect();
        var viewportCenter = window.innerHeight / 2;
        var elCenter = rect.top + rect.height / 2;
        var distance = elCenter - viewportCenter;
        var offset = distance * -0.08;
        var max = 40;
        if (offset > max) offset = max;
        if (offset < -max) offset = -max;
        el.style.setProperty('--parallax-offset', offset.toFixed(1) + 'px');
      });
      if (activeEls.size > 0) {
        rafId = requestAnimationFrame(tick);
      } else {
        rafId = null;
      }
    }

    function ensureLoop() {
      if (rafId === null && activeEls.size > 0) {
        rafId = requestAnimationFrame(tick);
      }
    }

    var observer =
      'IntersectionObserver' in window
        ? new IntersectionObserver(
            function (entries) {
              entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                  activeEls.add(entry.target);
                } else {
                  activeEls.delete(entry.target);
                }
              });
              ensureLoop();
            },
            { rootMargin: '20% 0px 20% 0px' }
          )
        : null;

    function observeAll(root) {
      var els = root.querySelectorAll
        ? root.querySelectorAll('[data-parallax]:not([data-parallax-bound])')
        : [];
      els.forEach(function (el) {
        el.setAttribute('data-parallax-bound', '');
        if (observer) observer.observe(el);
      });
    }

    observeAll(document);

    var mutationObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches('[data-parallax]')) {
            observeAll(node.parentNode || document);
          } else if (node.querySelectorAll) {
            observeAll(node);
          }
        });
      });
    });
    mutationObserver.observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
